import {IsAlphanumeric, MaxLength, Matches, IsOptional, IsNotEmpty } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
import { CusAddressInfo } from '../address.model';
export class CustomersDTO {
  @ApiProperty()
  @IsNotEmpty({message:"Customer id should not be empty"})
  @IsAlphanumeric()
  @IsOptional()
  custId: number;
  @ApiProperty()
  @MaxLength(15, { message: "Client Code allows maximum 15 characters" })
  @IsNotEmpty()
  @Matches(new RegExp("^[a-zA-Z0-9\\s]+$"),{ message:"Client Code should be only alpha numeric" })
  clientCode: string;
  @ApiProperty()
  @MaxLength(30, { message: "Client Name allows maximum 30 characters" })
  @IsNotEmpty()
  @Matches(new RegExp("^[a-zA-Z\\s]+$"),{ message:"Client name should be only alpha numeric" })
  clientName: string;
  @ApiProperty()
  @MaxLength(30, { message: "Account Type allows maximum 30 characters" })
  @IsNotEmpty()
  @Matches(new RegExp("^[a-zA-Z\\s]+$"),{ message:"Client name should be only alpha numeric" })
  accountType: string;
  @ApiProperty()
  @MaxLength(20, { message: "Gst Number allows maximum 20 characters" })
  @IsOptional()
  @Matches(new RegExp("^[0-9\\s]+$"),{ message:"Gst Number should be only numeric" })
  gstNumber: string;

  @ApiProperty()
  @MaxLength(25, { message: "website allows maximum 25 characters" })
  @IsOptional()
  @Matches(new RegExp("^[a-zA-Z0-9\\s]+$"),{ message:"website should be only alpha numeric" })
  website: string;
  @ApiProperty()
  @MaxLength(30, { message: "contact Person allows maximum 30 characters" })
  @IsNotEmpty()
  @Matches(new RegExp("^[a-zA-Z\\s]+$"),{ message:"contact Person should be only numeric" })
  contactPerson: string;
  @ApiProperty()
  @MaxLength(10, { message: "Phone Number allows maximum 10 characters" })
  @IsNotEmpty()
  @Matches(new RegExp("^[0-9\\s]+$"),{ message:"Phone Number should be only numeric" })
  phoneNo: string;
  @ApiProperty()
  @MaxLength(30, { message: "email allows maximum 10 characters" })
  @IsOptional()
  email: string;
  // @ApiProperty()
  // @MaxLength(30, { message: "street allows maximum 10 characters" })
  // @IsNotEmpty()
  // @Matches(new RegExp("^[a-zA-Z\\s]+$"),{ message:"Street should be only alpha numeric" })
  // street: string;
  // @ApiProperty()
  // @MaxLength(30, { message: "appartment allows maximum 10 characters" })
  // @IsNotEmpty()
  // @Matches(new RegExp("^[a-zA-Z\\s]+$"),{ message:"Appartment should be only alpha numeric" })
  // appartment: string;
  // @ApiProperty()
  // @MaxLength(30, { message: "city allows maximum 30 characters" })
  // @IsNotEmpty()
  // @Matches(new RegExp("^[a-zA-Z\\s]+$"),{ message:"city should be only alpha numeric" })
  // city: string;
  // @ApiProperty()
  // @MaxLength(30, { message: "state allows maximum 30 characters" })
  // @IsNotEmpty()
  // @Matches(new RegExp("^[a-zA-Z\\s]+$"),{ message:"state should be only alpha numeric" })
  // state: string;
  // @ApiProperty()
  // @MaxLength(30, { message: "postalCode allows maximum 30 characters" })
  // @IsNotEmpty()
  // @Matches(new RegExp("^[0-9\\s]+$"),{ message:"postalCode should be only numeric" })
  // postalCode: string;
  @ApiProperty()
  @MaxLength(30, { message: "currency allows maximum 30 characters" })
  @IsNotEmpty()
  @Matches(new RegExp("^[a-zA-Z\\s]+$"),{ message:"currency should be only alpha numeric" })
  currency: string;

  @ApiProperty()
  @MaxLength(30, { message: "payment Terms allows maximum 30 characters" })
  @IsNotEmpty()
  @Matches(new RegExp("^[a-zA-Z\\s]+$"),{ message:"payment Terms should be only alpha numeric" })
  paymentTerms: string;
  @ApiProperty()
  @MaxLength(30, { message: "Shipment Terms allows maximum 30 characters" })
  @IsNotEmpty()
  @Matches(new RegExp("^[a-zA-Z\\s]+$"),{ message:"Shipment Terms should be only alpha numeric" })
  shipmentTerms: string;
  @ApiProperty()
  @MaxLength(10, { message: "Phone Number allows maximum 10 characters" })
  @IsNotEmpty()
  @Matches(new RegExp("^[0-9\\s]+$"),{ message:"Payment Mode Id should be only numeric" })
  paymentModeId: number;
  @ApiProperty()
  @MaxLength(20, { message: "Rate per hour allows maximum 20 characters" })
  @IsNotEmpty()
  @Matches(new RegExp("^[0-9\\s]+$"),{ message:"Rate per hour should be only numeric" })
  ratePerHour: string;
  @ApiProperty()
  @MaxLength(50, { message: "publicNote allows maximum 20 characters" })
  @IsNotEmpty()
  @Matches(new RegExp("^[a-zA-Z0-9\\s]+$"),{ message:"publicNote should be only alpha numeric" })
  publicNote: string;
  @ApiProperty()
  @MaxLength(50, { message: "privateNote allows maximum 20 characters" })
  @IsNotEmpty()
  @Matches(new RegExp("^[a-zA-Z0-9\\s]+$"),{ message:"privateNote should be only alpha numeric" })
  privateNote: string;
  @ApiProperty()
  @MaxLength(50, { message: "privateNote allows maximum 20 characters" })
  @IsNotEmpty()
  @Matches(new RegExp("^[a-zA-Z0-9\\s]+$"),{ message:"customerAccountType should be only alpha numeric" })
  customerAccountType: string;
  @ApiProperty()
  @IsNotEmpty()
  countryId:number;
  @ApiProperty()
  isActive: boolean;

  createdAt : Date;

  @ApiProperty()
  @IsOptional()
  @MaxLength(40, { message: "Created User allows maximum 40 characters" })
  @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"),{ message: "created user should be only numbers" })
  createdUser : string;

  updatedAt : Date;
  @ApiProperty()
  @IsOptional()
  @MaxLength(40, { message: "Updated User allows maximum 40 characters"})
  @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"),{ message: "updated user should be only numbers" })
  updatedUser : string;

  @ApiProperty()
  versionFlag : number;

  @ApiProperty({ type: [CusAddressInfo]})
  cusAddressInfo: CusAddressInfo[];

}

